import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import moment from "moment";
import CssClass from "../../../Styles/common.module.css";
import Email_Unread_Icon from '../../../assets/Email_Unread_Icon.png';
import Tooltip from '@mui/material/Tooltip';
import classes from "../../../Styles/common.module.css";

const TicketListTable = (props) => {

  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //VIEW DEPLOYMENT FORM RESPONSE
  const onViewDeployment = (row) => {
    window.open(
      common.c_getApiUrl() +
        "api/ticket/ViewLatestDeploymentForm?_attachmentId=" +
        row.LATEST_DEPLOYMENT_ATTACHMENT_ID,
      "_blank"
    );
  };

  const onTicketDetailsHandler = (e, row) => {
    let functionName = "onTicketDetailsHandler";

    try {
      functionName = onTicketDetailsHandler.name;

      window.open("ViewTicket?_ticketNo=" + row.TICKET_NUM + "&_id=" + row.TICKET_MST_ID)

      // var newWindow = window.open("ViewTicket?_ticketNo=" + row.TICKET_NUM /*+ "&_id=" + row.TICKET_MST_ID*/)
      // newWindow["TICKET_MST_ID"] = row.TICKET_MST_ID;

    } catch (err) {
      common.c_LogWebError();
    }
  };

  const columns = [
    {
      accessorKey: "CREATE_DATETIME",
      header: "Created Datetime",
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    },
    // {
    //   accessorKey: "CREATE_BY",
    //   header: "Created By",
    // },
    {
      accessorKey: "CREATE_NAME",
      header: "Created By",
      size: 60,
    },
    // {
    //   accessorKey: "ORG_NAME",
    //   header: "Company",
    //   size: 60,
    // },
    {
      accessorKey: "SYSTEM_MST_NAME",
      header: "System",
      size: 60,
    },
    // {
    //   id: "ticketNo",
    //   header: "Ticket #",
    //   accessorFn: (row) => (
    //     `${row.TICKET_NUM} ${row.TICKET_MST_ID}`,
    //     <div>
    //       <span>
    //         <Comp.Button
    //           id="btnView"
    //           type="general"
    //           size="xl"
    //           onClick={(e) => onTicketDetailsHandler(e, row)}
    //         >
    //           {row.TICKET_NUM}
    //         </Comp.Button>
    //         {row.READ_FLAG === 'N' && row.READ_BY === userId && (
    //           <img
    //               src={Email_Unread_Icon}
    //               alt={""}
    //               style={{height: '30px', width: '30px'}}
    //           />
    //         )}
    //       </span>
    //     </div>
    //   )
    // },
    {
      accessorKey: "TICKET_NUM",
      header: "Ticket #",
      size: 160,

      Cell: ({ row }) => (
        <div>
          <span>
            <Comp.Button
              id="btnView"
              type="general"
              size="xl"
              onClick={(e) => onTicketDetailsHandler(e, row.original)}
            >
              {row.original.TICKET_NUM}
            </Comp.Button>

            {row.original.READ_FLAG === "N" &&
              row.original.READ_BY === userId && (
                <img
                  src={Email_Unread_Icon}
                  alt=""
                  style={{
                    height: "30px",
                    width: "30px"
                  }}
                />
            )}
          </span>
        </div>
      )
    },
    {
      id: "TICKET_STATUS_TYPE_NAME",
      header: "Status",
      accessorFn: (row) => {
        var className;
        switch(row.TICKET_STATUS_TYPE_NAME) {
          case "OPEN": 
            className = CssClass.openStatus;
            break;
          case "ACKNOWLEDGE":
            className = CssClass.ackStatus;
            break;
          case "CLOSED":
            className = CssClass.closeStatus;
            break;
          case "CANCEL":
            className = CssClass.cancelStatus;
            break;
          case "RESOLVED":
            className = CssClass.resolvedStatus;
            break;
          case "VERIFIED":
            className = CssClass.verifiedStatus;
            break;
        }
        return <span className={className}>{row.TICKET_STATUS_TYPE_NAME}</span>;
      }
    },
    {
      accessorKey: "SUBJECT",
      header: "Title",
      size: 300,
      Cell: ({ cell }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const text = cell.getValue();
        const maxLength = 100;
        // Toggle expand/collapse
        const toggleExpand = () => {
          setIsExpanded(prevState => !prevState);
        };
    
        return (
          <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {text?.length > maxLength ? (
              <>
                {/* Show either truncated or full text based on state */}
                {isExpanded ? text : text.substring(0, maxLength) + "..."} 
                &nbsp;
                {/* Toggle button */}
                <a 
                  onClick={toggleExpand}
                  style={{ 
                    color: '#007bff', 
                    cursor: 'pointer', 
                    textDecoration: 'none',
                    fontWeight: 'bold' 
                  }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                  >
                    {isExpanded ? "Show less" : "Read more"}
                </a>
              </>
            ) : (
              text
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "TICKET_DETAILS",
      header: "Details",
      size: 300,
      // Cell: ({ cell }) => (
      //   <span>
      //     {cell.getValue()?.length > 50 ? cell.getValue().substring(0, 50) + "..." : cell.getValue()}
      //   </span>
      // )
      Cell: ({ cell }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const text = cell.getValue();
        const maxLength = 100;
    
        // Toggle expand/collapse
        const toggleExpand = () => {
          setIsExpanded(prevState => !prevState);
        };
    
        return (
          <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {text?.length > maxLength ? (
              <>
                {/* Show either truncated or full text based on state */}
                {isExpanded ? text : text.substring(0, maxLength) + "..."} 
                &nbsp;
                {/* Toggle button */}
                <a 
                  onClick={toggleExpand}
                  style={{ 
                    color: '#007bff', 
                    cursor: 'pointer', 
                    textDecoration: 'none',
                    fontWeight: 'bold' 
                  }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                  >
                    {isExpanded ? "Show less" : "Read more"}
                </a>
              </>
            ) : (
              text
            )}
          </div>
        );
      },
      // Cell: ({ cell }) => {
      //   const text = cell.getValue();
      //   return (
      //     <div style={{
      //       maxHeight: '100px',        
      //       overflowY: 'auto',         
      //       whiteSpace: 'pre-wrap',    
      //       wordWrap: 'break-word',    
      //     }}>
      //       {/* Check if text is longer than 50 characters */}
      //       {text?.length > 50
      //         ? text.match(/.{1,50}/g).map((chunk, i) => (
      //             <span key={i}>{chunk}<br /></span>
      //           ))
      //         : text
      //       }
      //     </div>
      //   );
      // },
      // Cell: ({ cell }) => {
      //   const text = cell.getValue();
      //   return (
      //     <div style={{
      //       maxHeight: '500px',        // Set a max height for the cell to allow scrolling
      //       overflowY: 'auto',         // Enables vertical scrolling if text overflows
      //       whiteSpace: 'pre-wrap',    // Allows breaking lines at spaces and newline characters
      //       wordWrap: 'break-word',    // Breaks long words to fit within the container
      //     }}>
      //       {text?.length > 50 ? text : text}  {/* Display content, truncate or scroll if needed */}
      //     </div>
      //   );
      // },
    },
    {
      id: "DEPLOYMENT_FORM",
      header: "Deployment Form",
      size: 130,
      accessorFn: (row) => {
        if (!row.LATEST_DEPLOYMENT_ATTACHMENT_ID)
          return "-";

        return (
          <Comp.Button
            id="btnSave" 
            type="general"
            onClick={() => onViewDeployment(row)}
          >
            View
          </Comp.Button>
        );
      }
    },
    // {
    //   accessorKey: "TICKET_CATEGORY_NAME",
    //   header: "Category",
    // },
    // {
    //   accessorKey: "TICKET_PRIORITY_TYPE_NAME",
    //   header: "Priority",
    //   size: 60,
    // },
    // {
    //   accessorKey: "ACKNOWLEDGED_BY",
    //   header: "Agent",
    // },
    {
      accessorKey: "ACKNOWLEDGED_NAME",
      header: "Assigned To",
      size: 60,
    },
    {
      accessorKey: "LEAD_TIME",
      header: "Lead Time",
      size: 120,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        if (!val || val === "-") return "-";
        const parts = String(val).split(':'); // expected D:HH:MM
        let days = '0', hours = '00', mins = '00';
        if (parts.length >= 3) {
          days = parts[0];
          hours = String(parts[1]).padStart(2, '0');
          mins = String(parts[2]).padStart(2, '0');
        } else if (parts.length === 2) {
          hours = String(parts[0]).padStart(2, '0');
          mins = String(parts[1]).padStart(2, '0');
        } else {
          return val; // fallback
        }
        // return <span>{`${days}d ${hours}h ${mins}m`}</span>;
        const tooltipText = "Acknowledge - Closed";
        return (
          <Tooltip title={tooltipText} arrow>
            <span style={{ display: 'inline-block', cursor: 'default' }}>
              {`${days}d ${hours}h ${mins}m`}
            </span>
          </Tooltip>
        );
      },
    },
    {
      accessorKey: "TARGET_MANDAYS",
      header: "Target Mandays",
    },
    // {
    //   accessorKey: "TOTAL_COMPLETE_TIME",
    //   header: "Required Mandays",
    // },
    {
      accessorKey: "UPDATE_DATETIME",
      header: "Last Update",
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    },
    // {
    //   accessorKey: "UPDATE_ID",
    //   header: "Update By",
    // },
    {
      accessorKey: "UPDATE_NAME",
      header: "Update By",
      size: 60,
    },
  ];

  const filteredColumns = columns.filter(col => {
    // Hide "Lead Time" column for INTERNAL users
    if (col.accessorKey === "LEAD_TIME" && props.orgCategory === "CUSTOMER") {
      return false;
    }
    return true;
  });

  return (
    <>
      {/* <Comp.Table 
        columns={columns} 
        data={props.data} 
        invisibleCol={{
          TOTAL_COMPLETE_TIME: props.actionAuthority.WRITE !== "Y" ? false : true,
        }}
        enableStickyHeader 
      /> */}
      <Comp.HomeTable
        // columns={columns}
        columns={filteredColumns}
        data={props.data} 
        invisibleCol={{
          TOTAL_COMPLETE_TIME: props.actionAuthority.WRITE !== "Y" ? false : true,
        }}
        // height={"43vh"}
        height={"95vh"}
        width={"100%"}
        enableRowSelection={false}
        enableStickyHeader = {true}
        noRecordsToDisplay="No results match your search" // Your search returned no matches
      />
    </>
  );
};

export default TicketListTable;
